module.exports = __webpack_public_path__ + "static/media/RELI.2c14cf3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/RELI.jpg
// module id = 1574
// module chunks = 1